class mathUtils {

    constructor() {
        this.zoomfactor = this.PI = Math.PI;
        this.toMs = (this.PI2 = 2 * this.zoomfactor, this.HALF_PI = .5 * this.zoomfactor, this.DEG2RAD = this.zoomfactor / 180, this.RAD2DEG = 180 / this.zoomfactor, this.step = (start, now) => now < start ? 0 : 1, this.clamp = (value, max, min) => value < max ? max : min < value ? min : value);
        this.add = (this.mix = (min, max, percent) => min + (max - min) * percent, this.cMix = (startDayHour, endDayHour, hour) => startDayHour + (endDayHour - startDayHour) * toMs(hour, 0, 1), this.unMix = (key1, key2, t) => (t - key1) / (key2 - key1), this.cUnMix = (key1, key2, t) => toMs((t - key1) / (key2 - key1), 0, 1));
        this.callback = this.map = (input, iLower, iUpper, oLower, oUpper) => oLower + (oUpper - oLower) * (input - iLower) / (iUpper - iLower);
        this.hashKeyEvent = (this.cMap = (t, key1, key2, startDayHour, endDayHour) => startDayHour + (endDayHour - startDayHour) * toMs((t - key1) / (key2 - key1), 0, 1), this.fit = (n, target, params, start, end, callback) => (n = add(target, params, n), callback && (n = callback(n)), start + n * (end - start)), this.normalize = (record, buffer, mime) => callback(record, buffer, mime, 0, 1), this.smoothstep = (x, min, value) => (value = add(x, min, value)) * value * (3 - 2 * value), this.fract = x => x - Math.floor(x));
        this.isString = (this.hash = s => this.hashKeyEvent(43758.5453123 * Math.sin(s)), this.hash2 = (formatters, customFormatters) => this.hashKeyEvent(43758.5453 * Math.sin(12.9898 * formatters + 4.1414 * customFormatters)), this.sign = unprotectedHeader => unprotectedHeader ? unprotectedHeader < 0 ? -1 : 1 : 0, this.isPowerOfTwo = n => (n & -n) === n);
        this._removeSourceNodeSelected = this.powerTwoCeilingBase = maxend => Math.ceil(Math.log(maxend) / Math.log(2));
        this._getTrackPrefixUrl = (this.powerTwoCeiling = key => this.isString(key) ? key : 1 << this._removeSourceNodeSelected(key), this.powerTwoFloorBase = val => Math.floor(Math.log(val) / Math.log(2)));
    }

    /**
     * @param {number} url
     * @return {?}
     */
    powerTwoFloor(url) {
        return this.isString(url) ? url : 1 << this._getTrackPrefixUrl(url);
    };

    /**
     * @param {?} latitude1
     * @param {(boolean|number|string)} angle
     * @param {?} radians
     * @param {(boolean|number|string)} a
     * @return {?}
     */
    latLngBearing(latitude1, angle, radians, a) {
        /** @type {number} */
        var trueAnomalyY = Math.sin(a - angle) * Math.cos(radians);
        /** @type {number} */
        var mouseStartXFromCentre = Math.cos(latitude1) * Math.sin(radians) - Math.sin(latitude1) * Math.cos(radians) * Math.cos(a - angle);
        return Math.atan2(trueAnomalyY, mouseStartXFromCentre);
    };

    /**
     * @param {number} y
     * @param {number} x
     * @return {?}
     */
    distanceTo(y, x) {
        return Math.sqrt(y * y + x * x)
    };

    /**
     * @param {?} argR
     * @param {?} arg
     * @return {?}
     */
    distanceSqrTo(argR, arg) {
        return argR * argR + arg * arg;
    };

    /**
     * @param {?} argR
     * @param {?} arg
     * @param {?} braceToken
     * @return {?}
     */
    distanceTo3(argR, arg, braceToken) {
        return Math.sqrt(argR * argR + arg * arg + braceToken * braceToken);
    }

    /**
     * @param {?} argR
     * @param {?} arg
     * @param {?} braceToken
     * @return {?}
     */
    distanceSqrTo3(argR, arg, braceToken) {
        return argR * argR + arg * arg + braceToken * braceToken;
    }

    /**
     * @param {(boolean|number|string)} arg
     * @param {(boolean|number|string)} option
     * @param {(boolean|number|string)} value
     * @param {(boolean|number|string)} keepOnlyBoundary
     * @return {?}
     */
    latLngDistance(arg, option, value, keepOnlyBoundary) {
        /** @type {number} */
        var shLat = Math.sin((value - arg) / 2);
        /** @type {number} */
        var shLon = Math.sin((keepOnlyBoundary - option) / 2);
        /** @type {number} */
        var a = shLat * shLat + Math.cos(arg) * Math.cos(value) * shLon * shLon;
        return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    /**
     * @param {number} x
     * @param {string} t
     * @param {string} b
     * @param {string} x2
     * @param {number} y1
     * @return {?}
     */
    cubicBezier(x, t, b, x2, y1) {
        /** @type {number} */
        var width = 3 * (t - x);
        /** @type {number} */
        var y = 3 * (b - t) - width;
        /** @type {number} */
        var tileHeight = y1 * y1;
        return (x2 - x - width - y) * (tileHeight * y1) + y * tileHeight + width * y1 + x;
    };
    /**
     * @param {number} data
     * @param {string} oldData
     * @param {string} scope
     * @param {string} elem
     * @return {?}
     */
    cubicBezierFn(data, oldData, scope, elem) {
        /** @type {number} */
        var m = 3 * (oldData - data);
        /** @type {number} */
        var c = 3 * (scope - oldData) - m;
        /** @type {number} */
        var b = elem - data - m - c;
        return h => {
            /** @type {number} */
            var d = h * h;
            return b * (d * h) + c * d + m * h + data;
        };
    };
    /**
     * @param {number} x
     * @param {number} n
     * @return {?}
     */
    loop (x, n) {
        return x < 0 ? (n - Math.abs(x) % n) % n : x % n;
    };
}

const mathUtilsInstance = new mathUtils();

export default mathUtilsInstance;
